<template>
  <div class="flex m-5 quick-action cursor-pointer text-blue-500" :class="[color === 'red' ? 'text-red-500' : '']">
    <i :class="icon" class="text-2xl mr-4 action"></i>
    <div>
      <div class="text-lg font-medium mt-0.5 action">{{ title }}</div>
      <div class="text-sm font-medium text-gray-500" v-if="subtitle">{{ subtitle }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  icon: string;
  title: string;
  subtitle?: string;
  color?: 'red' | 'blue';
}>();
</script>

<style>
.quick-action:active .action {
  @apply text-sky-300;
}
</style>
